import { Component, OnInit} from '@angular/core';
import { Alert } from 'app/@core/data/alert';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-message-list-promp',
  templateUrl: './message-list-promp.component.html',
  styleUrls: ['./message-list-promp.component.scss']
})
export class MessageListPrompComponent implements OnInit {

  public messageList: Alert[] = null;
  screen: string = "GENERIC_ALERT";
  showMessageList: number;
  isVisible: boolean;


  ngOnInit(): void {
    //throw new Error('Method not implemented.');
  }

  constructor(
    public translate: TranslateService) {
    var result = localStorage.getItem("Messages");
    if (null != result) this.messageList = JSON.parse(result);
  }

  clear() {
    localStorage.removeItem("Messages");
    this.messageList = null;
  }

  showList(id: number): void {
    this.showMessageList = id;
    this.isVisible = !this.isVisible;
  }

}
